import {
  Directive,
  ViewChild,
  ElementRef,
  AfterViewInit,
  OnDestroy,
  Input,
  OnInit,
  NgIterable,
} from '@angular/core';
// import { SwiperService } from './carousel-service.service';
// import { OwlOptions } from 'ngx-owl-carousel-o';
// import { ICenterWidget } from '../custom-home/components/custom-center-carousel/custom-center-widget/custom-center-widget.component';
import { TranslateService } from '@ngx-translate/core';
// import { IsliderWidget } from '../../@core/shared/Components/slider-widget/slider-widget.component';
// import { IcommunitySlide } from '../home/components/community-carousel/community-carousel.component';
// import { serviceWidgetInterface } from '../../@core/shared/Components/service-widget/service-widget.component';
// import { IwidgetNewsArticle } from '../../@core/shared/Components/news-article-widget/news-article-widget.component';
// import { IDspaceWidget } from '../../@core/shared/Components/dspace-widget/dspace-widget.component';
// import { Partners } from '../../@AppService/interfaces/Partners';

  
@Directive() 
export abstract class BaseCarouselComponent implements OnInit, AfterViewInit {
  @Input({required:true}) slides: any[] |any = [];
  customOptions!: any;
  @ViewChild('swiperEl')
  swiperEl!: ElementRef;

  // #swiperEl
  constructor(public translate: TranslateService) {}
  swiperInitialized = true;

  ngAfterViewInit(): void {
    this.checkPaginationVisibility();
  }

  private checkPaginationVisibility(): void {
    const el = this.swiperEl?.nativeElement;
    if (!el) return;

    // Check once Swiper is ready
    setTimeout(() => this.updatePaginationClass(el), 200);

    // Re-check on window resize since isLocked may change
    window.addEventListener('resize', () => this.updatePaginationClass(el));
  }

  private updatePaginationClass(el: any): void {
    const swiper = el.swiper;
    if (swiper) {
      if (swiper.isLocked) {
        el.classList.add('single-slide');
      } else {
        el.classList.remove('single-slide');
      }
    }
  }

  ngOnInit(): void {
    this.translate.onLangChange.subscribe((val) => {
      // not called ever
      console.log(
        val.lang,
        'Language changed, updating carousel options...................................',
      );
      this.reinitSwiper();
    });

    if (this.slides.length < 4) {
      this.customOptions = {
        ...this.customOptions,
        loop: true,
        rewind: true,
        nav: true,
        dots: true,
      };
    }
  }
  private initSwiper(): void {
    const el = this.swiperEl.nativeElement;

    Object.assign(el, {
      spaceBetween: 16,
      freeMode: true,
      navigation: true,
      pagination: { clickable: true },
    });

    el.initialize();
    this.swiperInitialized = true;
    console.log('Swiper initialized');
  }
  private reinitSwiper(): void {
    const el = this.swiperEl.nativeElement;

    if (el.swiper) {
      el.swiper.destroy(true, true);
      this.swiperInitialized = false;
    }

    setTimeout(() => {
      this.initSwiper();
      this.updatePaginationClass(el);
    }, 50);
  }
}
